import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import 'flatpickr/dist/flatpickr.min.css';

/**
 * 見学希望日: 入力欄またはカレンダーボタンで日付ピッカーを開く
 */
export function initVisitDatepickers() {
	const roots = document.querySelectorAll('[data-visit-datepicker]');
	if (!roots.length) return;

	roots.forEach((wrap) => {
		flatpickr(wrap, {
			wrap: true,
			locale: Japanese,
			dateFormat: 'Y-m-d',
			altInput: true,
			altFormat: 'Y年n月j日',
			allowInput: true,
			disableMobile: true,
			minDate: 'today',
			appendTo: document.body,
			clickOpens: true,
		});
	});
}
